import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Add } from '../../service/EpinPurchaseService';
import { GetAll } from '../../service/LevelService';
import { GetByReferUserId } from '../../service/UserReferService';

export default function EpinPurchaseNew() {
  const {
    isLoading,
    setIsLoading,
    isAppError,
    setAppError,
    appErrorMessage,
    setAppErrorMessage,
    appErrorTitle,
    setAppErrorTitle,
    appErrorMode,
    setAppErrorMode,
    appUser
  } = useGlobalContext();

  const [price, setPrice] = useState('');
  const [unit, setUnit] = useState('');
  const [purchaseDate, setPurchaseDate] = useState('');
  const [remarks, setRemarks] = useState('');
  const [userId, setUserId] = useState('');

  const id = appUser.id;
  const [users, setUsers] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [limit] = useState(9999);
  const [totalPages, setTotalPages] = useState(1);

  const fetchUserReferList = async (currentPage = page) => {
    try {
      setIsLoading(true);
      const response = await GetByReferUserId(id, '', currentPage, limit, keyword);
      console.log("users", response);
      const activeUsers = (response.userRefers || []).filter(
        (item) => item.user && item.user.status === 'active'
      );
      setUsers(activeUsers);
      setTotalPages(response.totalPages || 1);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserReferList(page);
  }, [page]);

  const [levelId, setLevelId] = useState('');
  const [levels, setLevels] = useState([]);

  const FetchLevel = async () => {
    setIsLoading(true);
    try {
      const response = await GetAll(1, 9999, keyword);
      if (response && Array.isArray(response.levels)) {
        const activeLevels = response.levels.filter(cat => cat.status === "active");
        setLevels(activeLevels);
      } else {
        setAppError(true);
        setAppErrorMessage('No Level Found.');
      }
    } catch (error) {
      setAppError(true);
      setAppErrorMessage('Error loading master data');
      setAppErrorMode('Error');
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    FetchLevel();
  }, []);

  const saveEpinPurchase = async (event) => {
    event.preventDefault();

    if (!purchaseDate) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Purchase date is required");
      setAppErrorMode("error");
      return;
    }
    setIsLoading(true);

    try {
      const response = await Add(userId, levelId, price, unit, purchaseDate, remarks);
      console.log(response);
      if (response.status === 200) {
        setAppError(true);
        setAppErrorTitle("Action Response");
        setAppErrorMessage(response.message || "Epin Purchase Successfully Added");
        setAppErrorMode("success");
        window.location.href = "/epinPurchase/list";
      }
      else {
        setAppError(true);
        setAppErrorTitle("Error");
        setAppErrorMessage(response.message || "Failed to add epin purchase. Please try again.");
        setAppErrorMode("error");
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to add epin purchase. Please try again.");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Epin Purchase Manage | {config.appName}</title>
      </Helmet>
      <div className="container">
        <div className="page">
          <div className="page-heading">
            <h1>Epin Purchase Add</h1>
            <span>
              <Link to="/"> Dashboard </Link> / <Link to="/epinPurchase/list"> Epin Purchase List </Link> / EpinPurchase Manage
            </span>
          </div>
          <div className="page-content">
            <div className="portal">
              <div className="portal-body">
                <div className="form">
                  <form onSubmit={saveEpinPurchase} encType='multipart/form-data'>
                    <div className='row'>
                      <div className='col-lg-3 col-md-6 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Member</label>
                          <select
                            className="form-control"
                            value={userId}
                            onChange={(e) => setUserId(e.target.value)}
                          >
                            <option value="">Select Member</option>
                            {users.map(userOption => (
                              <option key={userOption.user.id} value={userOption.user.id}>
                                {userOption.user.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className='col-lg-3 col-md-6 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Level</label>
                          <select
                            className="form-control"
                            value={levelId}
                            onChange={(e) => setLevelId(e.target.value)}
                          >
                            <option value="">Select Level</option>
                            {levels.map(levelOption => (
                              <option key={levelOption.id} value={levelOption.id}>
                                {levelOption.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Price</label>
                          <input
                            className='form-control'
                            type='number'
                            value={price}
                            onChange={(e) => setPrice(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Unit</label>
                          <input
                            className='form-control'
                            type='number'
                            value={unit}
                            onChange={(e) => setUnit(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Purchase Date</label>
                          <input
                            className='form-control'
                            type='date'
                            value={purchaseDate}
                            onChange={(e) => setPurchaseDate(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className='col-lg-9 col-md-4 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Remarks</label>
                          <input
                            className='form-control'
                            type='text'
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className='clearfix'></div>
                      <div className='col-12 text-end'>
                        <div className="mb-3">
                          <button type='reset' className='btn btn-danger btn-md'>
                            <i className="ri-reset-right-line"></i> Reset
                          </button>
                          &nbsp;&nbsp;
                          <button type='submit' className='btn btn-success btn-md'>
                            <i className="ri-check-fill"></i> Add Epin Purchase
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
